import { Component, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { filter, takeWhile } from 'rxjs';
import { PartnerDataModel } from 'src/app/account/models/accountModel';
import { AccountService } from 'src/app/account/services/account.service';
import { AppSide, ComponentNames, SectionNames, UserRoles } from 'src/app/constants';
import { PartnerListDataModel } from 'src/app/management/models/managementModel';
import { SharedDataService } from 'src/app/shared/shared-data.service';
import { SharedService } from 'src/app/shared/shared.service';
import { FormElement } from 'src/app/shared/sharedModel';
import { environment } from 'src/environments/environment';
declare let bootstrap: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  @Input() isLoggedIn: boolean = false;

  user: PartnerDataModel;

  isCustomerUser = false;

  masquerading_user_id = '';

  isLoginScreen = false;

  routerSubscription: any;

  destroySubscription = false;

  environment = environment;

  partialLoggedIn: boolean;

  userRoles = UserRoles;

  updatePartnerPopup: any;

  partner_app_access_levels: any = [];

  partner_registration_statuses: any = [];

  partnerData: PartnerListDataModel;

  updatePartnerForm: NgForm;

  partnerUpdateFormElemConfig: FormElement;

  componentNames = ComponentNames;

  sectionNames = SectionNames;

  constructor(private renderer: Renderer2, private router: Router, private accountService: AccountService,
    private sharedDataService: SharedDataService, private sharedService: SharedService
  ) {
    this.accountService.partialLoggedIn.pipe(takeWhile(() => !this.destroySubscription))
      .subscribe((response: any) => {
        if (response) {
          this.partialLoggedIn = response;
        } else {
          this.partialLoggedIn = false;
        }
      });
    this.routerSubscription = this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        if (event && (event.url.indexOf('dashboard/login') > -1)) {
          this.isLoginScreen = true;
        } else if (event && (event.url.indexOf('dashboard/login') === -1)) {
          this.isLoginScreen = false;
        }
      });

    this.user = this.accountService.getUser() ? this.accountService.getUser() : null;
    if (this.user) {
      this.userInfoInit(this.user);
    }
    this.accountService.user.pipe(takeWhile(() => !this.destroySubscription))
      .subscribe((response: any) => {
        if (response) {
          this.user = response;
          if (this.user) {
            this.userInfoInit(this.user);
          }
        }
      });
  }

  userInfoInit(user: PartnerDataModel) {
    if (user.customer_name) {
      this.isCustomerUser = true;
    }
    if (user.masquerading_user_id) {
      this.masquerading_user_id = user.masquerading_user_id;
    }
  }

  ngOnInit(): void {
    this.sharedDataService.singlePartnerDataSub.pipe(takeWhile(() => !this.destroySubscription)).subscribe({
      next: (response: any) => {
        if (response) {
          this.partnerData = this.sharedDataService.updatePartnerDataModel(response);
          this.openUpdatePartnerPopup();
          // console.log('form', this.updatePartnerForm);
          // this.updatePartnerForm.form.markAllAsTouched();
        }
      }
    });
    this.sharedDataService.updatePartnerDataSub.pipe(takeWhile(() => !this.destroySubscription)).subscribe({
      next: (response: any) => {
        this.updatePartnerForm.reset();
        setTimeout(() => {
          this.updatePartnerPopup.hide();
        });
      }
    });
    const metadata = this.sharedService.getStoreMetadata();
    if (metadata) {
      if (metadata.partner_app_access_levels && metadata.partner_app_access_levels.length) {
        metadata.partner_app_access_levels.forEach((accessLevel: string) => {
          if (accessLevel === 'BETA' || accessLevel === 'GA') {
            this.partner_app_access_levels.push(accessLevel);
          }
        });
      }

      this.partner_registration_statuses = metadata.partner_registration_statuses;
    }
    this.partnerUpdateFormElemConfig = JSON.parse(JSON.stringify(this.sharedDataService.partnerUpdateFormElemConfig));
    this.partnerUpdateFormElemConfig.fields!.partnerUpdateFormFields!.partner_name!.readOnly = true;
    this.partnerUpdateFormElemConfig.fields!.partnerUpdateFormFields!.short_name!.readOnly = true;
    this.partnerUpdateFormElemConfig.fields!.partnerUpdateFormFields!.registration_status!.visible = false;
    this.partnerUpdateFormElemConfig.fields!.partnerUpdateFormFields!.ns_org_id!.visible = false;
    this.partnerUpdateFormElemConfig.fields!.partnerUpdateFormFields!.ns_org_id!.visible = false;
  }

  toggleMenu() {
    const elSidebar: any = document.getElementById('sidebar');
    const elMain: any = document.getElementById('main');
    const action = elSidebar.classList.contains('active') ? 'removeClass' : 'addClass';
    this.renderer[action](elSidebar, 'active');
    this.renderer[action](elMain, 'isSidebar');
  }

  goToHome() {
    this.accountService.goHome();
  }

  logout() {
    this.accountService.logout();
  }

  settings() {
    // this.sharedDataService.settingsMenuDataSub.next(true);
    this.sharedDataService.getPartner(this.user.partner_id, AppSide.storeSide);
  }

  openUpdatePartnerPopup() {
    this.updatePartnerPopup = new bootstrap.Modal(document.getElementById("updatePartnerModal"), {});
    this.updatePartnerPopup.show();
  }

  updatePartnerFormChange(event: any) {
    if (event && event.formData) {
      this.updatePartnerForm = event.formData;
    }
  }

  updatePartner() {
    this.sharedDataService.updatePartner(this.partnerData, AppSide.storeSide);
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
    this.destroySubscription = true;
  }
}
